import React from "react";
import logger from "logger";
import Tooltip from "@material-ui/core/Tooltip";

export const ToolbarButton = (props) => {
  const { label, tooltip, onClick } = props;
  return (
    <Tooltip title={tooltip}>
      <button className="toolbarbutton" type="button" onClick={onClick}>
        {label}
      </button>
    </Tooltip>
  );
};
